import React from "react";

export default function ComparisonCard({ data }) {

  const AddToCompare = (item) => {
    let compareData = localStorage.getItem('compareData');
    if (compareData) {
      compareData = JSON.parse(compareData);
      let isExist = compareData.find((i) => i.bankName === item.bankName);
      if (isExist) {
        alert("Item already in compare");
      } else {
        compareData.push(item);
        localStorage.setItem('compareData', JSON.stringify(compareData));
        alert("Item added to compare");
      }
    } else {
      localStorage.setItem('compareData', JSON.stringify([item]));
      alert("Item added to compare");
    }
    console.log("potta", compareData);

  };

  return (
    <section className="pt-10 pb-50 choose-card-area bg_disable">
      <div className="container">
        <div className="row mt-20 gy-lg-0 gy-4" style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", overflow: "auto", scrollbarWidth: "none" }}>
          {data?.tableData.map((item, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="credit-card-box-widget wow fadeInUp" data-wow-delay="0.1s">
                <div className="card-content">
                  <div style={{ display: "flex", alignItems: "center", justifyItems: "center", flexDirection: "row", flexWrap: "wrap", gap: "10px" }}>
                    <img src={item.bankImage} alt="img" style={{width:"45px",height:"45px"}} className="w-10 h-10" />
                    <h4>{item.bankName}</h4>
                  </div>
                  <p>
                    <span><img src="img/card/icon-1.png" alt="icon" /></span>
                    TENURE: {item.tenure}
                  </p>
                  <p>
                    <span><img src="img/card/icon-2.png" alt="icon" /></span>
                    IR RATE: {item.interestRate}
                  </p>
                  <p>
                    <span><img src="img/card/icon-3.png" alt="icon" /></span>
                    LOAN AMOUNT: {item.loanAmount}
                  </p>
                  <div style={{cursor:"pointer"}} onClick={() => AddToCompare(item)} className="mt-25">
                    Add to Compare <i className="arrow_right" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
